
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.77 7.864a6.545 6.545 0 0012.718 2.182M2.769 7.864l2.182 1.454M2.77 7.864l-1.454 2.182m14.545-2.91A6.545 6.545 0 003.142 4.955M15.86 7.136L13.68 5.682m2.181 1.454l1.455-2.181","stroke":"#ABAFB5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    